import styled from 'styled-components';

export const ComponentWrapper = styled.div`
  width: 100%;
`;

export const InputWrapper = styled.div`
  width: 100%;
  position: relative;
  line-height: 0;
  margin-bottom: 15px;
`;

export const InputLabel = styled.div<{ $fontSize: string }>`
  font-size: ${props => props.$fontSize};
  text-transform: uppercase;
  opacity: 0.7;
  color: ${({ theme }) => theme.baseBlue.a10};
  position: absolute;
  left: 12px;
  top: 6px;
  transition: all 0.3s;
  line-height: normal;
  z-index: 2;

  &.invalid {
    color: ${({ theme }) => theme.red.a10};
  }
`;

export const ErrorMsg = styled.div.attrs({ className: 'caption_text' })`
  margin: 7px 0 0 15px;
  color: ${({ theme }) => theme.red.a10};
  font-style: italic;
  font-weight: 300;
`;
